export var ROOT_FONT_SIZE_PIXELS = 16;
export var SPACING_UNIT_PX = 4;
export var SPACING_UNIT_REM = 0.5;
export var spacing = numberOfUnits => {
  return "".concat(numberOfUnits * SPACING_UNIT_PX / ROOT_FONT_SIZE_PIXELS, "rem");
};
export var SPACING_PRESETS = {
  globalLeftMarginDesktop: spacing(20),
  globalRightMarginDesktop: spacing(20),
  globalLeftMarginMobile: spacing(5),
  globalRightMarginMobile: spacing(5)
};